import actionTypes from "./actionTypes";
import * as oAuthUtils from "../utils/oAuthUtils";

const registerOAuthRequest = () => ({
  type: actionTypes.CREATE_USER_OAUTH_REQUEST,
});
const registerOAuthSuccess = (res) => ({
  type: actionTypes.CREATE_USER_OAUTH_SUCCESS,
  res,
});
const registerOAuthFailure = (error) => ({
  type: actionTypes.CREATE_USER_OAUTH_FAILURE,
  error,
});
export const registerOAuth = (code, redirect_uri, provider) => {
  return async (dispatch) => {
    try {
      dispatch(registerOAuthRequest());
      let oAuthUser = await oAuthUtils.register(code, redirect_uri, provider);
      dispatch(registerOAuthSuccess(oAuthUser));
    } catch (error) {
      dispatch(registerOAuthFailure(error));
    }
  };
};

const loginOAuthRequest = () => ({
  type: actionTypes.LOGIN_OAUTH_REQUEST,
});
const loginOAuthSuccess = (res) => ({
  type: actionTypes.LOGIN_OAUTH_SUCCESS,
  res,
});
const loginOAuthFailure = (error) => ({
  type: actionTypes.LOGIN_OAUTH_FAILURE,
  error,
});
export const loginOAuth = (code, redirect_uri, provider) => {
  return async (dispatch) => {
    try {
      dispatch(loginOAuthRequest());
      let user = await oAuthUtils.login(code, redirect_uri, provider);
      dispatch(loginOAuthSuccess(user));
    } catch (error) {
      dispatch(loginOAuthFailure(error));
    }
  };
};
